import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "marketing-page" };
const _hoisted_2 = { class: "marketing-header" };
const _hoisted_3 = { class: "marketing-header-inner" };
const _hoisted_4 = { class: "header-tabs-wrapper" };
const _hoisted_5 = { class: "header-tabs" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "tab-icon" };
const _hoisted_8 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_9 = {
    key: 1,
    class: "marketing-content"
};
const _hoisted_10 = { class: "tab-content" };
const _hoisted_11 = { class: "templates-grid" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "template-card-icon" };
const _hoisted_14 = { class: "template-card-info" };
const _hoisted_15 = { class: "template-locales" };
const _hoisted_16 = { class: "tab-content" };
const _hoisted_17 = { class: "field-group" };
const _hoisted_18 = { class: "delay-options" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "tab-content" };
const _hoisted_21 = { class: "field-group" };
const _hoisted_22 = { class: "delay-options" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { class: "tab-content" };
const _hoisted_25 = { class: "field-group" };
const _hoisted_26 = { class: "delay-options" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "tab-content" };
const _hoisted_29 = { class: "tab-content" };
const _hoisted_30 = { class: "tab-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AutomationConfigCard = _resolveComponent("AutomationConfigCard");
    const _component_AutomationHistoryTable = _resolveComponent("AutomationHistoryTable");
    const _component_AutomationStepEditor = _resolveComponent("AutomationStepEditor");
    const _component_EmailTemplateEditor = _resolveComponent("EmailTemplateEditor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"header-title\" data-v-9fb82e9c><div class=\"header-icon\" data-v-9fb82e9c><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-9fb82e9c><path d=\"M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-9fb82e9c></path><path d=\"M22 6L12 13L2 6\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-9fb82e9c></path></svg></div><div data-v-9fb82e9c><h1 class=\"page-title\" data-v-9fb82e9c>Messages Automatiques</h1><p class=\"page-subtitle\" data-v-9fb82e9c>Configurez les envois automatiques d&#39;emails et de notifications push</p></div></div>", 1)),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: tab.id,
                                class: _normalizeClass(['tab-btn', { active: _ctx.activeTab === tab.id }]),
                                onClick: ($event) => (_ctx.activeTab = tab.id)
                            }, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(tab.icon), 1),
                                _createElementVNode("span", null, _toDisplayString(tab.label), 1)
                            ], 10, _hoisted_6));
                        }), 128))
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "tabs-scroll-hint" }, [
                        _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        }, [
                            _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
                        ])
                    ], -1))
                ])
            ])
        ]),
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "spinner" }, null, -1),
                    _createElementVNode("p", null, "Chargement des configurations...", -1)
                ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("div", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-intro" }, [
                        _createElementVNode("p", null, "Personnalisez les 12 templates d'emails envoyés à vos clients. Chaque template peut être traduit en 4 langues et inclure votre logo et couleurs de marque.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatesMeta, (template) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: template.key,
                                class: "template-card",
                                onClick: ($event) => (_ctx.openTemplateEditor(template))
                            }, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getTemplateEmoji(template.key)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("h3", null, _toDisplayString(_ctx.getTemplateName(template.key)), 1),
                                    _createElementVNode("p", null, [
                                        _cache[4] || (_cache[4] = _createTextVNode("Variables : ", -1)),
                                        _createElementVNode("code", null, _toDisplayString(template.variables.slice(0, 3).join(', ')) + _toDisplayString(template.variables.length > 3 ? '...' : ''), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['fr', 'en', 'de', 'it'], (loc) => {
                                            return _createElementVNode("span", {
                                                key: loc,
                                                class: _normalizeClass(['locale-badge', { configured: _ctx.isConfigured(template.key, loc) }])
                                            }, _toDisplayString(loc.toUpperCase()), 3);
                                        }), 64))
                                    ])
                                ]),
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "template-card-arrow" }, [
                                    _createElementVNode("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2"
                                    }, [
                                        _createElementVNode("path", { d: "M9 18l6-6-6-6" })
                                    ])
                                ], -1))
                            ], 8, _hoisted_12));
                        }), 128))
                    ])
                ], 512), [
                    [_vShow, _ctx.activeTab === 'templates']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_AutomationConfigCard, {
                        config: _ctx.getConfig('CART_REMINDER'),
                        type: "CART_REMINDER",
                        title: "Rappel Panier (Paiement en attente)",
                        description: "Relancez les clients qui ont commencé une commande mais n'ont pas encore payé.",
                        "franchise-id": _ctx.franchiseId,
                        "coupon-templates": _ctx.couponTemplates,
                        onSaved: _ctx.onConfigSaved,
                        onToggled: _ctx.onConfigToggled
                    }, {
                        delay: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "field-label" }, "Délai avant envoi", -1)),
                                _createElementVNode("div", _hoisted_18, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delayHoursOptions.slice(0, 8), (h) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: h.value,
                                            class: _normalizeClass(['delay-btn', { active: _ctx.getConfig('CART_REMINDER')?.delay_hours === h.value }]),
                                            onClick: ($event) => (_ctx.updateDelay('CART_REMINDER', 'delay_hours', h.value))
                                        }, _toDisplayString(h.label), 11, _hoisted_19));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["config", "franchise-id", "coupon-templates", "onSaved", "onToggled"]),
                    _createVNode(_component_AutomationHistoryTable, {
                        "config-id": _ctx.getConfig('CART_REMINDER')?.id,
                        "franchise-id": _ctx.franchiseId
                    }, null, 8, ["config-id", "franchise-id"])
                ], 512), [
                    [_vShow, _ctx.activeTab === 'cart_pending']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_AutomationConfigCard, {
                        config: _ctx.getConfig('ABANDONED_CART_EVENT'),
                        type: "ABANDONED_CART_EVENT",
                        title: "Panier Abandonné (Sites & Apps)",
                        description: "Relancez automatiquement les clients qui ajoutent des produits au panier sans jamais passer à la caisse.",
                        "franchise-id": _ctx.franchiseId,
                        "coupon-templates": _ctx.couponTemplates,
                        onSaved: _ctx.onConfigSaved,
                        onToggled: _ctx.onConfigToggled
                    }, {
                        delay: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "field-label" }, "Délai après le dernier ajout (heures)", -1)),
                                _createElementVNode("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delayHoursOptions.slice(0, 8), (h) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: h.value,
                                            class: _normalizeClass(['delay-btn', { active: _ctx.getConfig('ABANDONED_CART_EVENT')?.delay_hours === h.value }]),
                                            onClick: ($event) => (_ctx.updateDelay('ABANDONED_CART_EVENT', 'delay_hours', h.value))
                                        }, _toDisplayString(h.label), 11, _hoisted_23));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["config", "franchise-id", "coupon-templates", "onSaved", "onToggled"]),
                    _createVNode(_component_AutomationHistoryTable, {
                        "config-id": _ctx.getConfig('ABANDONED_CART_EVENT')?.id,
                        "franchise-id": _ctx.franchiseId
                    }, null, 8, ["config-id", "franchise-id"])
                ], 512), [
                    [_vShow, _ctx.activeTab === 'cart_abandoned']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_AutomationConfigCard, {
                        config: _ctx.getConfig('REENGAGEMENT_INACTIVE'),
                        type: "REENGAGEMENT_INACTIVE",
                        title: "Relance Clients Inactifs",
                        description: "Envoyez un message automatique aux clients qui n'ont pas commandé depuis un certain temps pour les faire revenir.",
                        "franchise-id": _ctx.franchiseId,
                        "coupon-templates": _ctx.couponTemplates,
                        onSaved: _ctx.onConfigSaved,
                        onToggled: _ctx.onConfigToggled
                    }, {
                        delay: _withCtx(() => [
                            _createElementVNode("div", _hoisted_25, [
                                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "field-label" }, "Inactivité après la dernière commande (jours)", -1)),
                                _createElementVNode("div", _hoisted_26, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delayDaysOptions, (d) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: d.value,
                                            class: _normalizeClass(['delay-btn', { active: _ctx.getConfig('REENGAGEMENT_INACTIVE')?.delay_days === d.value }]),
                                            onClick: ($event) => (_ctx.updateDelay('REENGAGEMENT_INACTIVE', 'delay_days', d.value))
                                        }, _toDisplayString(d.label), 11, _hoisted_27));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["config", "franchise-id", "coupon-templates", "onSaved", "onToggled"]),
                    _createVNode(_component_AutomationHistoryTable, {
                        "config-id": _ctx.getConfig('REENGAGEMENT_INACTIVE')?.id,
                        "franchise-id": _ctx.franchiseId
                    }, null, 8, ["config-id", "franchise-id"])
                ], 512), [
                    [_vShow, _ctx.activeTab === 'inactifs']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_AutomationConfigCard, {
                        config: _ctx.getConfig('ONBOARDING_PUSH'),
                        type: "ONBOARDING_PUSH",
                        title: "Nurturing Post-Inscription",
                        description: "Envoyez une séquence de messages aux nouveaux clients qui n'ont pas encore commandé.",
                        "franchise-id": _ctx.franchiseId,
                        onSaved: _ctx.onConfigSaved,
                        onToggled: _ctx.onConfigToggled
                    }, {
                        delay: _withCtx(() => [
                            _createVNode(_component_AutomationStepEditor, {
                                config: _ctx.getConfig('ONBOARDING_PUSH'),
                                "franchise-id": _ctx.franchiseId,
                                onSaved: _ctx.onConfigSaved
                            }, null, 8, ["config", "franchise-id", "onSaved"])
                        ]),
                        _: 1
                    }, 8, ["config", "franchise-id", "onSaved", "onToggled"]),
                    _createVNode(_component_AutomationHistoryTable, {
                        "config-id": _ctx.getConfig('ONBOARDING_PUSH')?.id,
                        "franchise-id": _ctx.franchiseId
                    }, null, 8, ["config-id", "franchise-id"])
                ], 512), [
                    [_vShow, _ctx.activeTab === 'onboarding']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_AutomationConfigCard, {
                        config: _ctx.getConfig('ORDER_PUSH'),
                        type: "ORDER_PUSH",
                        title: "Confirmation Commande (Push)",
                        description: "Envoyez une notification push instantanée à chaque nouvelle commande validée.",
                        "franchise-id": _ctx.franchiseId,
                        onSaved: _ctx.onConfigSaved,
                        onToggled: _ctx.onConfigToggled
                    }, null, 8, ["config", "franchise-id", "onSaved", "onToggled"]),
                    _createVNode(_component_AutomationHistoryTable, {
                        "config-id": _ctx.getConfig('ORDER_PUSH')?.id,
                        "franchise-id": _ctx.franchiseId
                    }, null, 8, ["config-id", "franchise-id"])
                ], 512), [
                    [_vShow, _ctx.activeTab === 'order']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_AutomationConfigCard, {
                        config: _ctx.getConfig('BIRTHDAY'),
                        type: "BIRTHDAY",
                        title: "Offre d'Anniversaire",
                        description: "Envoyez automatiquement un coupon de réduction à vos clients le jour de leur anniversaire.",
                        "franchise-id": _ctx.franchiseId,
                        "coupon-templates": _ctx.couponTemplates,
                        onSaved: _ctx.onConfigSaved,
                        onToggled: _ctx.onConfigToggled
                    }, null, 8, ["config", "franchise-id", "coupon-templates", "onSaved", "onToggled"]),
                    _createVNode(_component_AutomationHistoryTable, {
                        "config-id": _ctx.getConfig('BIRTHDAY')?.id,
                        "franchise-id": _ctx.franchiseId
                    }, null, 8, ["config-id", "franchise-id"])
                ], 512), [
                    [_vShow, _ctx.activeTab === 'birthday']
                ])
            ])),
        (_ctx.editorOpen)
            ? (_openBlock(), _createBlock(_component_EmailTemplateEditor, {
                key: 2,
                "template-meta": _ctx.selectedTemplate,
                "franchise-id": _ctx.franchiseId,
                "existing-configs": _ctx.existingTemplates,
                onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.editorOpen = false)),
                onSaved: _ctx.onTemplateSaved
            }, null, 8, ["template-meta", "franchise-id", "existing-configs", "onSaved"]))
            : _createCommentVNode("", true)
    ]));
}
